/**
 * WordPress dependencies
 */
import { __, _x } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import deprecated from './deprecated';
import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/image",
  category: "common",
  attributes: {
    align: {
      type: "string"
    },
    url: {
      type: "string",
      source: "attribute",
      selector: "img",
      attribute: "src"
    },
    alt: {
      type: "string",
      source: "attribute",
      selector: "img",
      attribute: "alt",
      "default": ""
    },
    caption: {
      type: "string",
      source: "html",
      selector: "figcaption"
    },
    href: {
      type: "string",
      source: "attribute",
      selector: "figure > a",
      attribute: "href"
    },
    rel: {
      type: "string",
      source: "attribute",
      selector: "figure > a",
      attribute: "rel"
    },
    linkClass: {
      type: "string",
      source: "attribute",
      selector: "figure > a",
      attribute: "class"
    },
    id: {
      type: "number"
    },
    width: {
      type: "number"
    },
    height: {
      type: "number"
    },
    sizeSlug: {
      type: "string"
    },
    linkDestination: {
      type: "string",
      "default": "none"
    },
    linkTarget: {
      type: "string",
      source: "attribute",
      selector: "figure > a",
      attribute: "target"
    }
  }
};
import save from './save';
import transforms from './transforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Image'),
  description: __('Insert an image to make a visual statement.'),
  icon: icon,
  keywords: ['img', // "img" is not translated as it is intended to reflect the HTML <img> tag.
  __('photo')],
  example: {
    attributes: {
      sizeSlug: 'large',
      url: 'https://upload.wikimedia.org/wikipedia/commons/1/15/MtBlanc1.JPG',
      caption: __('Mont Blanc appears—still, snowy, and serene.')
    }
  },
  styles: [{
    name: 'default',
    label: _x('Default', 'block style'),
    isDefault: true
  }, {
    name: 'circle-mask',
    label: _x('Circle Mask', 'block style')
  }],
  transforms: transforms,
  getEditWrapperProps: function getEditWrapperProps(attributes) {
    var align = attributes.align,
        width = attributes.width;

    if ('left' === align || 'center' === align || 'right' === align || 'wide' === align || 'full' === align) {
      return {
        'data-align': align,
        'data-resized': !!width
      };
    }
  },
  edit: edit,
  save: save,
  deprecated: deprecated
};
//# sourceMappingURL=index.js.map